import { Fragment, useState } from "react";
import Config from "../../../Config";


import g_ubrania from "../../../wyprawka/g_ubrania.png";
import g_chusteczki from "../../../wyprawka/g_chusteczki.png";
import g_chusteczki_nawilzone from "../../../wyprawka/g_chusteczki_nawilzone.png";
import g_money from "../../../wyprawka/g_money.png";
import g_pampers from "../../../wyprawka/g_pampers.png";
import g_pasta from "../../../wyprawka/g_pasta.png";
import g_szczoteczka from "../../../wyprawka/g_szczoteczka.png";
import g_milk from "../../../wyprawka/g_milk.png";


function Layette(props)
{

    
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);


    const getData = () => {


        props.mainView.setProgress(-2);
 

        fetch( Config.url + '/rest_v1_parents,layette', {
            method: 'POST', 
            body: JSON.stringify({}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);                                                                                         
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
               



    }




    
    if(tab == null)
        {
            setTab([]);
            getData();      
            return (
                <div></div>
            );        
        }


    
    if(refreshView != props.userData.refreshView)
    {         
          setRefreshView( props.userData.refreshView);
          setTab(null);
    }    



    var razemOczekuje = 0;

    for(var w = 0; w<tab.length; w++)
    {
        if( tab[w].zrealizowano == 0 ) razemOczekuje++;
    }



    return <div className="gocentermobile">


                    {
                        tab.length == 0  &&
                        <div className="big_msg">
                            Aktualnie nie muszisz nic dostarczyć.
                        </div>
                    }
            

            <ul className="parents_eat">
                   
                  

                    {
                        tab.map( (item, ix) => {

                            return <Fragment>

                                <li>
                                    <div className="calColor">

                                        {
                                            item.chusteczki_nawilzajace == 1 &&
                                            <img className="p_img_layette" src={g_chusteczki_nawilzone}/>
                                        }
                                        
                                        {
                                            item.chusteczki_suche == 1 &&
                                            <img className="p_img_layette" src={g_chusteczki}/>
                                        }

                                        {
                                            item.pampersy == 1 &&
                                            <img className="p_img_layette" src={g_pampers}/>
                                        }


                                        {
                                            item.ubrania == 1 &&
                                            <img className="p_img_layette" src={g_ubrania}/>
                                        }

                                        {
                                            item.pasta_do_zebow == 1 &&
                                            <img className="p_img_layette" src={g_pasta}/>
                                        }

                                        {
                                            item.szczoteczka == 1 &&
                                            <img className="p_img_layette" src={g_szczoteczka}/>
                                        }

                                        {
                                            item.zbiorka_pieniedzy == 1 &&
                                            <img className="p_img_layette"  src={g_money}/>
                                        }

                                        {
                                            item.mleko == 1 &&
                                            <img className="p_img_layette" src={g_milk}/>
                                        }

                                        {item.opis}
                                    </div>
                                    <div>
                                          {item.data}, {item.dodal_nazwisko} {item.dodal_imie}     

                                            {
                                                item.zrealizowano == 0 &&
                                                <span className="link_bad  " title="Oczekuje na dostarczenie przez rodzica">&nbsp; stan: oczekuje</span>
                                            }

                                            {
                                                item.zrealizowano == 1 &&
                                                <span className="link_color  " title="Dostarczone przez rodzica">&nbsp;  stan: dostarczono, data dostarczenia: {item.data}</span>
                                            }

                                    </div>
                                  
                                </li>

                            </Fragment>

                        } )
                    }
            </ul>

    </div>
}


export default Layette;